import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import './TechnologyDetailHero.css';

const TechnologyDetailHero = ({ title, description, backgroundImage }) => {
  return (
    <Box className="technology-detail-hero">
      <div className="technology-detail-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="technology-detail-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="technology-detail-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Expertise
          </Typography>
          <Typography
            variant="h1"
            className="technology-detail-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            TECHNOLOGY STACK
          </Typography>
          <Typography
            className="technology-detail-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            We leverage cutting-edge technologies and frameworks to build scalable, 
            high-performance solutions. Our expertise spans across modern web development, 
            cloud computing, and enterprise software, ensuring your project is built with 
            the best tools for success.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default TechnologyDetailHero; 